module.exports = __webpack_public_path__ + "img/kindle-381242_1280-min.1e04609c.jpg";